import { Injectable, TemplateRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type SidebarTemplate = {
  template: TemplateRef<any>;
  onClose?: () => void;
  showDefaultHeader?: boolean;
};

export type OverlayTemplate = {
  template: TemplateRef<any>;
};

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly sidebarContentSubject = new BehaviorSubject<SidebarTemplate>(null);
  private readonly sidebarOpenSubject = new BehaviorSubject<boolean>(false);
  private readonly overlayContentSubject = new BehaviorSubject<OverlayTemplate>(null);

  sidebarContent$ = this.sidebarContentSubject.asObservable();
  sidebarOpen$ = this.sidebarOpenSubject.asObservable();
  overlayContent$ = this.overlayContentSubject.asObservable();
  
  setSidebarContent(content: SidebarTemplate) {
    this.sidebarContentSubject.next(content);
  }

  setOverlayContent(content: OverlayTemplate) {
    this.overlayContentSubject.next(content);
  }

  toggleSidebar(isOpen: boolean) {
    this.sidebarOpenSubject.next(isOpen);
    if (!isOpen) {
      this.sidebarContentSubject.next(null);
      this.overlayContentSubject.next(null);
    }
  }
}
